module.exports = __webpack_public_path__ + "img/14.aec5ba19.png";